import { useEffect, useState } from 'react';

/* ==========================================================================
   Relógio do servidor para as contagens da solicitação de cancelamento
   (change orders-customer-cancellation, D21)

   "Responda em 4:12" é contado contra o relógio do servidor, e não o do
   navegador: o computador da loja com o relógio errado não pode dar mais ou
   menos prazo do que o servidor dá. O deslocamento vem do `serverTime` da
   lista de solicitações (`GET /orders/cancellation-requests`), a única
   leitura que o traz; antes dela, vale o relógio do navegador.
   ========================================================================== */

let offsetMs = 0;

/** Guarda o deslocamento entre o servidor e o navegador, a partir de uma leitura. */
export function recordServerTime(serverTime: string, receivedAt = Date.now()): void {
  const server = Date.parse(serverTime);
  if (!Number.isNaN(server)) offsetMs = server - receivedAt;
}

/** Agora, no relógio do servidor. */
export function serverClockNow(browserNow = Date.now()): number {
  return browserNow + offsetMs;
}

/** Só para os testes. */
export function resetServerClock(): void {
  offsetMs = 0;
}

/** Milissegundos até o prazo, nunca negativo. */
export function remainingMs(deadline: string, now: number): number {
  const end = Date.parse(deadline);
  return Number.isNaN(end) ? 0 : Math.max(0, end - now);
}

/** "4:12" (minutos e segundos, arredondando o segundo para cima, para o zero ser o prazo). */
export function formatCountdown(ms: number): string {
  const totalSeconds = Math.max(0, Math.ceil(ms / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${String(seconds).padStart(2, '0')}`;
}

/**
 * Agora no relógio do servidor, com nova renderização a cada `intervalMs`
 * enquanto `active` (a contagem regressiva na tela).
 */
export function useServerNow(active: boolean, intervalMs = 1000): number {
  const [, setTick] = useState(0);
  useEffect(() => {
    if (!active) return undefined;
    const id = setInterval(() => setTick((tick) => tick + 1), intervalMs);
    return () => clearInterval(id);
  }, [active, intervalMs]);
  return serverClockNow();
}
